// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apply-job-container{
    width:60%;
    display: flex;
    flex-direction: column;
    padding: 20px 25%;
    padding-top: 130px;
}

.apply-job-container h2{
    text-align: left;
    font-family: 'Raleway',sans-serif;
    font-weight: 500;
    letter-spacing: 1px;

}

form{
    display: flex;
    flex-direction: column;
}
.job-form label{
    text-align: left;
    font-family: 'Poppins',sans-serif;
    letter-spacing: 1px;
    color:#444;
    font-size: 16px;
}

.job-form b{
    color:red;
}

.job-form input{
    width:70%;
    height:50px;
}

.job-form textarea{
    width: 70%;
        height: 200px;

}

.apply-job-container button{
    width: 150px;
        height: 50px;
        background-color:#e42727 ;
        color: #fff;
        font-family: 'Poppins', sans-serif;
        letter-spacing: 1px;
        border-radius: 10px;
        position: relative;
            overflow: hidden;
            cursor: pointer;
        
            z-index: 0;
}










.apply-job-container button::after {
     /* this is what all  will be done when mouse outs from the button */
     content: "";
     position: absolute;
     left: 0;
     top: 0;
     height: 100%;
     width: 100%;
     background-color: #f9c12e;
     z-index: -1;

     transition: 0.3s ease all;
     transform: scale(0, 1);

     /* this is you are to change for diffirent transition; */

     transform-origin: bottom left;
     transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
     transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
 }



 .apply-job-container button:hover::after {
     transform: scale(1, 1);
     transform-origin: top left;
 }

.job-form{
    display: flex;
    flex-direction: column;
}

@media screen and (max-width:768px){
    .apply-job-container {
            width: 90%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px ;
            padding-top: 180px;
        }
        .job-form input {
            width: 90%;
            height: 50px;
        }
        .job-form textarea {
            width: 90%;
            height: 200px;
    
        }
}

`, "",{"version":3,"sources":["webpack://./src/Styles/Apply.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;IACnB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;QACN,aAAa;;AAErB;;AAEA;IACI,YAAY;QACR,YAAY;QACZ,yBAAyB;QACzB,WAAW;QACX,kCAAkC;QAClC,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;YACd,gBAAgB;YAChB,eAAe;;YAEf,UAAU;AACtB;;;;;;;;;;;AAWA;KACK,mEAAmE;KACnE,WAAW;KACX,kBAAkB;KAClB,OAAO;KACP,MAAM;KACN,YAAY;KACZ,WAAW;KACX,yBAAyB;KACzB,WAAW;;KAEX,yBAAyB;KACzB,sBAAsB;;KAEtB,wDAAwD;;KAExD,6BAA6B;KAC7B,0DAA0D;KAC1D,0DAA0D;CAC9D;;;;CAIA;KACI,sBAAsB;KACtB,0BAA0B;CAC9B;;AAED;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;YACQ,UAAU;YACV,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,cAAc;YACd,kBAAkB;QACtB;QACA;YACI,UAAU;YACV,YAAY;QAChB;QACA;YACI,UAAU;YACV,aAAa;;QAEjB;AACR","sourcesContent":[".apply-job-container{\n    width:60%;\n    display: flex;\n    flex-direction: column;\n    padding: 20px 25%;\n    padding-top: 130px;\n}\n\n.apply-job-container h2{\n    text-align: left;\n    font-family: 'Raleway',sans-serif;\n    font-weight: 500;\n    letter-spacing: 1px;\n\n}\n\nform{\n    display: flex;\n    flex-direction: column;\n}\n.job-form label{\n    text-align: left;\n    font-family: 'Poppins',sans-serif;\n    letter-spacing: 1px;\n    color:#444;\n    font-size: 16px;\n}\n\n.job-form b{\n    color:red;\n}\n\n.job-form input{\n    width:70%;\n    height:50px;\n}\n\n.job-form textarea{\n    width: 70%;\n        height: 200px;\n\n}\n\n.apply-job-container button{\n    width: 150px;\n        height: 50px;\n        background-color:#e42727 ;\n        color: #fff;\n        font-family: 'Poppins', sans-serif;\n        letter-spacing: 1px;\n        border-radius: 10px;\n        position: relative;\n            overflow: hidden;\n            cursor: pointer;\n        \n            z-index: 0;\n}\n\n\n\n\n\n\n\n\n\n\n.apply-job-container button::after {\n     /* this is what all  will be done when mouse outs from the button */\n     content: \"\";\n     position: absolute;\n     left: 0;\n     top: 0;\n     height: 100%;\n     width: 100%;\n     background-color: #f9c12e;\n     z-index: -1;\n\n     transition: 0.3s ease all;\n     transform: scale(0, 1);\n\n     /* this is you are to change for diffirent transition; */\n\n     transform-origin: bottom left;\n     transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n     transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n }\n\n\n\n .apply-job-container button:hover::after {\n     transform: scale(1, 1);\n     transform-origin: top left;\n }\n\n.job-form{\n    display: flex;\n    flex-direction: column;\n}\n\n@media screen and (max-width:768px){\n    .apply-job-container {\n            width: 90%;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            padding: 20px ;\n            padding-top: 180px;\n        }\n        .job-form input {\n            width: 90%;\n            height: 50px;\n        }\n        .job-form textarea {\n            width: 90%;\n            height: 200px;\n    \n        }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
